<div class="wrapper">
    <div class="header">
        <div class="search"> 
          <div class="search-bar Custom-Search mx-auto mt-3">
            <input   type="search" class="form-control" style="border-radius: 5px; height: 45px; padding-left: 20px !important; height: 30px;" placeholder="Search by Name, Employee Id, Competency, etc.." [(ngModel)]="searchText" matinput=""  type="text"
              (keyup)="applyFilter($event.target.value)">
              <button type="submit" class="msicon" (click)="clearSearchText()" *ngIf="searchText!=''"><span
                class="material-symbols-outlined"> close </span></button>
            <button type="submit" class="msicon"><span class="material-symbols-outlined">
                search</span></button>
          </div> 
    </div>
      </div>
        
     
    <div class="data-grid"> 
      <mat-table
        #table
        [dataSource]="(dataSource?.data.length > 0 || loading) ? dataSource : emptyData"
        matSort
        class="employees-table"
      > 
        <!-- ID Column -->
        <ng-container matColumnDef="employeeId">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Employee ID </mat-header-cell>      
          <mat-cell *matCellDef="let row"> <a  class="foreColor" (click)="pageNavigate(row.employeeId)">{{row.employeeId}}</a></mat-cell> 
        </ng-container> 
        <!-- Progress Column -->
        <ng-container matColumnDef="firstName">
          <mat-header-cell *matHeaderCellDef mat-sort-header> First Name </mat-header-cell>
          <mat-cell *matCellDef="let row"> 
            <span style="text-overflow: ellipsis;overflow: hidden;" matTooltip="{{row.firstName}}" matTooltipPosition="above">
              {{row.firstName}} 
            </span>
            
          </mat-cell>
        </ng-container> 
        <!-- Name Column -->
        <ng-container matColumnDef="lastName">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span style="text-overflow: ellipsis;overflow: hidden;" matTooltip="{{row.lastName}}" matTooltipPosition="above">
              {{row.lastName}} 
            </span>
              
            </mat-cell>
        </ng-container>
  
        <!-- Color Column -->
        <ng-container matColumnDef="emailId">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Email Id </mat-header-cell>

          <mat-cell *matCellDef="let row">
             <span matTooltip="{{ row.emailId }}" matTooltipPosition="above">
              <span style="text-overflow: ellipsis;overflow: hidden;" matTooltip="{{ row.emailId }}" matTooltipPosition="above">
                {{ row.emailId }} 
              </span>
              
            </span>
            </mat-cell>
        </ng-container>
  
        <ng-container matColumnDef="competency">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Competency </mat-header-cell>
          <mat-cell *matCellDef="let row"> 
            <span style="text-overflow: ellipsis;overflow: hidden;" matTooltip="{{row.competency}}" matTooltipPosition="above">
              {{row.competency ? row.competency : 'Not Mapped' }} 
            </span>
            
          </mat-cell>
        </ng-container>
  
        <ng-container matColumnDef="subCompetency">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Sub-Competency </mat-header-cell>
          <mat-cell *matCellDef="let row"> 
            <span style="text-overflow: ellipsis;overflow: hidden;" matTooltip="{{row.subCompetency}}" matTooltipPosition="above">
              {{row.subCompetency ? row.subCompetency : 'Not Mapped'}}
            </span>
             
          </mat-cell>
        </ng-container> 
        <ng-container matColumnDef="SkillSet">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Skill Set</mat-header-cell>
          <mat-cell *matCellDef="let row"> 
            
            <span style="text-overflow: ellipsis;overflow: hidden;" matTooltip="{{getskillset(row.skillSet) }}" matTooltipPosition="above">
              {{getskillset(row.skillSet) ? getskillset(row.skillSet) :'Not Available'}}
            </span>
          </mat-cell>             
        </ng-container>  
        <ng-container matColumnDef="empty-row">
          <mat-cell style="height: 100%;" *matCellDef="let element" >
            <div class="noDataCard mt-0">
              <div class="noDataCardIn">
                <img src="../../../assets/images/no_data.png" height="120px"><br>
                <span class="mt-3 d-block" > No Records Found for your Search criteria</span> 
              </div>
            </div>
          </mat-cell>
        </ng-container>     
        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" ></mat-header-row>
        <mat-row
        [class.odd]="i % 2 == 1"
        [class.even]="i % 2 == 0"
        *matRowDef="let row; columns: dataSource?.data.length > 0 ? displayedColumns : ['empty-row']; let i = index;">
        </mat-row>
      </mat-table>

  <!-- Pagination -->
      
      <mat-paginator *ngIf="totalRecords > 0" [length]="totalRecords" [pageSize]="size" [pageSizeOptions]="[10,20,40,50,60]" aria-label="Select page"
        (page)="getPaginatorData($event)" style=" height: 8vh;background: inherit; width: 98%; margin-left: 16px;"></mat-paginator>
        
    </div> 
  </div> 
